export const CT_OPTIONS = [
  { value: 1.0, label: "Dry connection (loose, click, velcro, magnetic)" },
  { value: 0.8, label: "Connection with added elements (bolt, nut, spring, corner, screw)" },
  { value: 0.6, label: "Direct integral connection (pin, nail)" },
  { value: 0.2, label: "Soft chemical connection" },
  { value: 0.1, label: "Hard chemical connection" }
];

export const CA_OPTIONS = [
  { value: 1.0, label: "Freely accessible without additional actions" },
  { value: 0.8, label: "Accessible with additional actions, no damage" },
  { value: 0.6, label: "Accessible with additional actions, fully repairable damage" },
  { value: 0.4, label: "Accessible with additional actions, partially repairable damage" },
  { value: 0.1, label: "Not accessible – irreparable damage to product/surroundings" }
];

export const INDEP_OPTIONS = [
  { value: 1.0, label: "No independency, modular zoning of products/elements from different layers" },
  { value: 0.4, label: "Occasional independency of products/elements from different layers" },
  { value: 0.1, label: "Full integration of products/elements from different layers" }
];

export const GPE_OPTIONS = [
  { value: 1.0, label: "Open, no obstacle to (interim) removal of products/elements" },
  { value: 0.4, label: "Overlapping, partial obstruction to (interim) removal" },
  { value: 0.1, label: "Closed, complete obstruction to (interim) removal" }
];

export const DISASSEMBLY_EASE_OPTIONS = [
  {
    value: "dry_fit",
    label: "Dry-fit, fully modular (click, Velcro, magnetic)",
    ct: 1.0,
    ca: 1.0,
    indep: 1.0,
    gpe: 1.0,
  },
  {
    value: "bolted_screwed",
    label: "Bolted or screwed, accessible",
    ct: 0.8,
    ca: 0.8,
    indep: 0.4,
    gpe: 0.4,
  },
  {
    value: "pinned_nailed",
    label: "Pinned or nailed, some access",
    ct: 0.6,
    ca: 0.6,
    indep: 0.4,
    gpe: 0.4,
  },
  {
    value: "adhesive_bonded",
    label: "Adhesive-bonded, damage on access",
    ct: 0.2,
    ca: 0.2,
    indep: 0.1,
    gpe: 0.1,
  },
  {
    value: "chemically_bonded",
    label: "Chemically bonded / embedded, irreparable",
    ct: 0.1,
    ca: 0.1,
    indep: 0.1,
    gpe: 0.1,
  },
];

const DEFAULT_DISASSEMBLY_PRESET = "bolted_screwed";

const toFactors = ({ ct, ca, indep, gpe }) => ({ ct, ca, indep, gpe });

// Global fallback used only when a row carries no factors and no category preset.
export const DEFAULT_DISASSEMBLY_FACTORS = toFactors(
  DISASSEMBLY_EASE_OPTIONS.find((o) => o.value === DEFAULT_DISASSEMBLY_PRESET)
);

/**
 * Category default DfD factors for a circularity row. The backend assigns
 * `default_dfd_preset` per material type; unknown presets use the global fallback.
 */
export const getDefaultDisassemblyFactors = (row) => {
  const preset = DISASSEMBLY_EASE_OPTIONS.find((o) => o.value === row?.default_dfd_preset);
  return preset ? toFactors(preset) : DEFAULT_DISASSEMBLY_FACTORS;
};

export const getDisassemblyEaseOption = (ct, ca, indep, gpe) => {
  if (typeof ct === "string") {
    const byVal = DISASSEMBLY_EASE_OPTIONS.find((o) => o.value === ct);
    if (byVal) return byVal;
  }
  if (ct && typeof ct === "object" && ct.value) {
    const directMatch = DISASSEMBLY_EASE_OPTIONS.find((o) => o.value === ct.value);
    if (directMatch) return directMatch;
  }

  const nCt = typeof ct === "number" ? ct : (parseFloat(ct) || DEFAULT_DISASSEMBLY_FACTORS.ct);

  if (nCt >= 0.9) return DISASSEMBLY_EASE_OPTIONS[0]; // Dry-fit (1.0)
  if (nCt >= 0.7) return DISASSEMBLY_EASE_OPTIONS[1]; // Bolted / screwed (0.8)
  if (nCt >= 0.4) return DISASSEMBLY_EASE_OPTIONS[2]; // Pinned / nailed (0.6)
  if (nCt >= 0.15) return DISASSEMBLY_EASE_OPTIONS[3]; // Adhesive (0.2)
  return DISASSEMBLY_EASE_OPTIONS[4]; // Chemical (0.1)
};

